import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList} from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Link} from "react-router-dom"
import axios from "axios";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer} from "react-toastify";
import Moment from 'moment';
import * as myConstList from "./baseUrl"

const baseUrl = myConstList.baseUrl
const token = localStorage.getItem("jwtToken");
const configs = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
class Users_Complete_record extends Component {

    constructor(props) {
        super(props);

        this.columns = [
            {
                // key: "id",
                text: "S.No.",
                className: "id",
                align: "left",
                sortable: true,
                cell:(row, index)=>index+1
            },
           
            {
                key: "email",
                text: "Email",
                className: "email",
                align: "left",
                sortable: true
            },
            {
                key: "kycstatus",
                text: "KYC Status",
                className: "status",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                          {record.kycstatus}
                        </Fragment>
                    );
                }
            },
            {
                key: "selfistatus",
                text: "Selfie Status",
                className: "status",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                          {record.kycstatus}
                        </Fragment>
                    );
                }
            },
          
          
            {
                key: "updatedAt",
                text: "Date & Time",
                className: "date",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                          {Moment(record.updatedAt).format('lll')}
                        </Fragment>
                    );
                }
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                cell: record => {
                    return (
                        <Fragment>
                            <Link to={"/verifyKyc/" + record._id } className="admin_btn mr-2 ml-2 pt-1 pb-1">View</Link>
                            {/* <button
                                className="btn btn-primary btn-sm"
                                onClick={() => this.unBlockRecordMgs(record)}>
                                <i class="fa fa-unlock-alt"></i>
                            </button> */}
                        </Fragment>
                    );
                }
            }
            
       
        ];

        this.config = {
            page_size: 10,
            length_menu: [ 10, 20, 50 ],
            filename: "Verify Completed List ",
            no_data_text: 'No user found!',
            button: {
               
                // print: true,
                // csv: true
            },
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Search in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: []
        };

      

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        if (this.props.auth.user.verifyComplete !==undefined && this.props.auth.user.verifyComplete !==1 ) {
            this.props.history.push("/dashboard");
        }
        this.getData();
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.user.verifyComplete !==undefined && nextProps.auth.user.verifyComplete !==1 ) {
            this.props.history.push("/dashboard");
        }
        this.getData();
    }

    getData() {
        axios
            .get(baseUrl + "/api/v1/getkycverified",configs)
            .then(res => {
                this.setState({ records: res.data.user})
            })
            .catch()
    }

    editRecord(record) {
        this.setState({ currentRecord: record});
    }

    deleteRecord(record) {
        axios
            .post(baseUrl + "/api/user-delete", {_id: record._id})
            .then(res => {
                if (res.status === 200) {
                   toast(res.data.message, {
                       position: toast.POSITION.TOP_CENTER,
                   })
                }
            })
            .catch();
        this.getData();
    }

    pageChange(pageData) {
        console.log("OnPageChange", pageData);
    }

    render() {
        return (
            <div>
                <Navbar/>
                <div className="d-flex" id="wrapper">
                    <Sidebar/>
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <button className="btn btn-link mt-3" id="menu-toggle"><FontAwesomeIcon icon={faList}/></button>
                              <h4 className="mt-2 man_hadding mb-3">Users Complete Verify List</h4>
                              <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                              />
                        </div>
                    </div>
                    <ToastContainer/>
                </div>
            </div>
        );
    }

}

Users_Complete_record.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    records: state.records
});

export default connect(
    mapStateToProps
)(Users_Complete_record);
